import { useCallback } from "react";

import type { ProTicketPurchaseInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { TICKET_PRO_PURCHASE_MUTATION } from "./schema";
import { HOTEL_APPLICATION_DATA_QUERY } from "../../hotel-application-data/query/schema";

export const useTicketProPurchaseMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(TICKET_PRO_PURCHASE_MUTATION, {
		refetchQueries: [HOTEL_APPLICATION_DATA_QUERY], // キャッシュの更新を行う
	});

	/**
	 *
	 * @todo Notify などの副作用的な処理を実行元で定義する
	 *
	 */
	const onUpdateTicketProPurchase = useCallback(
		async (input: ProTicketPurchaseInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => hideLoadingScreenCallback());

			if (errors && errors.length) {
				return false;
			} else {
				return true;
			}
		},
		[mutationFunc, showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return { onUpdateTicketProPurchase };
};
